export default __webpack_public_path__ + "static/media/misc.060fd1bb.svg";